import { render, staticRenderFns } from "./TabStatusInvoiceAp.vue?vue&type=template&id=145cfe7c&"
import script from "./TabStatusInvoiceAp.vue?vue&type=script&lang=ts&"
export * from "./TabStatusInvoiceAp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('145cfe7c')) {
      api.createRecord('145cfe7c', component.options)
    } else {
      api.reload('145cfe7c', component.options)
    }
    module.hot.accept("./TabStatusInvoiceAp.vue?vue&type=template&id=145cfe7c&", function () {
      api.rerender('145cfe7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-ap/TabStatusInvoiceAp.vue"
export default component.exports